<template>
  <AbsPopup id="RadioSelect" :title="title" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <li v-for="(item, index) in list" :key="index">
          <label><input type="radio" name="select" v-model="item.index" :value="index" @change="radioChange"/>{{ item.text }}</label>
        </li>
        <li>
          <label><input type="radio" name="select" :value="list.length" @change="radioChange"/>
          기타 ({{ commentEx.length }}/500)</label>
          <UInput v-if="parseInt(commentIdx) === list.length" type="textarea" :limitHeight="100" line="box" :auto="true" placeholder="신고 사유와 하실 말씀을 적어 주세요" v-model="commentEx" :limit="500" @focus="$store.commit('popup', false)" @focusout="$store.commit('popup', true)"/>
        </li>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.title = this.option.param.title
    this.list = this.option.param.list
    this.$emit('loading', false)
  },
  data: () => {
    return {
      title: '',
      commentEx: '',
      commentIdx: -1,
      list: []
    }
  },
  name: 'RadioSelect',
  computed: {
  },
  methods: {
    radioChange (e) {
      console.log(e.target.value)
      this.commentIdx = e.target.value
      switch (e.target.value) {
        case this.list.length :
          break
        default :
          this.commentEx = ''
          break
      }
    },
    submit () {
      var param = ''
      if (document.querySelector('input[name=select]:checked').value >= this.list.length) {
        param = {text: this.commentEx}
      } else {
        param = this.list[document.querySelector('input[name=select]:checked').value]
      }
      param.index = document.querySelector('input[name=select]:checked').value
      this.$emit('submit', param)
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#RadioSelect {
  padding: 10px 0;
  color: var(--text-base);
  width: 400px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 0px;
}
.popup-body li {
  display: flex;
  flex-direction: column;
  line-height: 30px;
  padding: 0px 20px;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/RadioSelect.vue